<template>
  <div class="balance-withdraws">
    <bp-table-header :total="pagination.count" @refresh="refresh">
      <bp-export-button
        slot="buttons"
        action="financial/exportWithdraws"
        filename="withdraws"
      />
    </bp-table-header>

    <bp-data-table
      class="my-6"
      :data="withdraws"
      :columns="columns"
      :loading="loading"
    >
      <template #dados-bancários="{value}">
        <div class="functional-1">{{ getBankData(value) }}</div>
        <div class="functional-2 text-neutral-400">
          {{ getAccountData(value) }}
        </div>
      </template>
    </bp-data-table>

    <bp-paginator
      v-model="page"
      :pagination="pagination"
      @change-page="dispatch"
    />
  </div>
</template>
<script>
import { formatMoney } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";

export default {
  props: {
    showValues: Boolean
  },
  data() {
    return {
      loading: false,
      exportLoading: false,
      columns: [
        {
          name: "Saque em",
          field: "withdraw_at",
          transform: this.formatDate
        },
        {
          name: "Solicitado em",
          field: "created_at",
          transform: this.formatDate
        },
        {
          name: "Valor recebido",
          field: "amount",
          transform: v => `R$ ${this.formatMoney(v)}`
        },
        {
          name: "Titular",
          field: "account_bank",
          transform: this.getAccountOwner
        },
        {
          name: "Dados bancários",
          field: "account_bank",
          size: "2fr"
        },
        {
          name: "Status",
          field: "status",
          type: "tag",
          color: this.formatStatusColor,
          transform: this.formatStatus,
          size: "0.7fr"
        }
      ],
      pagination: {},
      page: 1
    };
  },
  computed: {
    ...mapState("financial", ["withdraws", "bankAccounts", "banksList"])
  },
  methods: {
    formatMoney,
    formatDate(val) {
      if (!val) return "-";
      return moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    _getAccount(val) {
      return this.bankAccounts.find(item => item.id == val) || {};
    },
    getAccountOwner(id) {
      let account = this._getAccount(id);
      return account.owner_account;
    },
    getBankData(val) {
      let account = this._getAccount(val);
      let bank = this.banksList.find(b => b.id === account.bank) || {};
      return bank.compe + " - " + bank.long_name;
    },
    getAccountData(val) {
      let account = this._getAccount(val);
      return `A. ${account.agency}${
        account.agency_vd ? "-" + account.agency_vd : ""
      } C. ${account.number_account}${
        account.number_account_vd ? "-" + account.number_account_vd : ""
      }`;
    },
    formatStatus(val) {
      let statuses = {
        requested: "Solicitado",
        approved: "Aprovado",
        denied: "Negado",
        in_review: "Em revisão",
        reject: "Rejeitado"
      };
      return statuses[val];
    },
    formatStatusColor(val) {
      let colors = {
        requested: "alert",
        approved: "positive",
        denied: "negative",
        in_review: "alert",
        reject: "negative"
      };
      return colors[val];
    },

    setPagination(data) {
      let { count, next, previous } = data;
      this.pagination = { count, next, previous };
    },
    dispatch(offset) {
      this.loading = true;
      this.$store
        .dispatch("financial/getWithdraws", { offset })
        .then(data => {
          this.setPagination(data);
        })
        .finally(() => (this.loading = false));
    },
    refresh() {
      this.page = 1;
      this.dispatch();
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>
